









































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Chapter from '@/interfaces/models/Chapter';
import Flow from '@/interfaces/models/Flow';
import draggable from 'vuedraggable';
import AssetCard from '@/components/AssetCard.vue';
import PresentationSlideCard from '@/components/presentation/PresentationSlideCard.vue';
import { getScopeFromRouter, changeQuery } from '@/router';
import Slide from '@/interfaces/models/Slide';
import PresentationFilter from '@/components/presentation/PresentationFilter.vue';
import PresentationItemAdded from '@/interfaces/models/PresentationItemAdded';
import PresentationSortUpdate from '@/interfaces/models/PresentationSortUpdate';
import { ExportService } from '@/services/modules/export';
import ProductCountry from '@/interfaces/models/ProductCountry';
import PresentationMeta from '@/components/presentation/PresentationMeta.vue';
import DndEvent from '@/interfaces/packages/DndEvent';
import { FilterState } from '@/stores/modules/filter';
import moment from 'moment';
import SlideFilterBoundary from '../../hoc/SlideFilterBoundary.vue';
import LazyLoadingComponent from '../../components/LazyLoadingComponent.vue';
import { EventBus } from '../../event-bus';
import Modal from '../../components/core/Modal.vue';
import { updateStructure } from '../../services/graph/asset.graph';
import { confirm } from '../../utils/modal';
import Product from '@/interfaces/models/Product';

const ps = namespace('presentation');
const alert = namespace('alerts');
const filter = namespace('filter');
const lib = namespace('library');
const product = namespace('product');

@Component({
  components: {
    PresentationMeta,
    PresentationFilter,
    PresentationSlideCard,
    AssetCard,
    draggable,
    filterBoundary: SlideFilterBoundary,
    lazyLoading: LazyLoadingComponent,
    Modal: Modal
  }
})
export default class PresentationDetail extends Vue {
  @ps.Getter('detail') detailItem!: (type: 'chapter' | 'flow', id: string) => Flow | Chapter;
  @lib.State('items') items!: string[];
  @lib.State('map') itemMap!: { [key: string]: Slide };
  @lib.State(x => x.meta.counts) counts!: { all: number; filtered: number };

  @product.State('products') products!: Product[];

  @filter.State('filter') filter!: FilterState['filter'];
  @filter.Mutation('setFilterItem') setFilterItem!: (a: {
    key: keyof FilterState['filter'];
    val: any;
  }) => void;
  @filter.Mutation('resetFilter') resetFilter!: () => void;

  get slides() {
    return this.items.map((id: string) => {
      return this.itemMap[id];
    });
  }

  @ps.State('flows') flows!: Flow[];
  @ps.State('chapters') chapters!: Chapter[];

  @ps.Action('getFlows') getFlows!: (selection: ProductCountry | null) => Promise<void>;
  @ps.Action('getChapters') getChapters!: (selection: ProductCountry | null) => Promise<void>;
  @ps.Action('deleteFlow') deleteFlow!: (id: string) => Promise<void>;
  @ps.Action('deleteChapter') deleteChapter!: (id: string) => Promise<void>;
  @ps.Action('sortFlow') sortFlow!: (update: PresentationSortUpdate) => Promise<void>;
  @ps.Action('sortChapter') sortChapter!: (update: PresentationSortUpdate) => Promise<void>;
  @ps.Action('assignSlideToFlow') assignSlideToFlow!: (update: PresentationItemAdded) => Promise<void>;
  @ps.Action('assignSlideToChapter') assignSlideToChapter!: (update: PresentationItemAdded) => Promise<void>;
  @ps.Action('deassignSlideFromFlow') deassignSlideFromFlow!: (
    update: PresentationSortUpdate
  ) => Promise<void>;
  @ps.Action('deassignSlideFromChapter') deassignSlideFromChapter!: (
    update: PresentationSortUpdate
  ) => Promise<void>;

  @alert.Action('success') notifySuccess!: (msg: string) => void;

  search: string | null = null;
  activeItem: string | null = null;
  mode: 'view' | 'edit' = 'view';

  get id(): string {
    return this.$route.params.id;
  }

  get type(): 'flow' | 'chapter' {
    return this.$route.params.type as 'flow' | 'chapter';
  }

  get detail() {
    return this.detailItem(this.type, this.id);
  }

  async mounted() {
    // TODO: move to router hook
    // -> redirect if no data present
    const scope = getScopeFromRouter();
    if (!scope) {
      return;
    }

    await Promise.all([this.getChapters(scope), this.getFlows(scope)]);

    if (!this.slides) {
      this.redirectToIndex();
      return;
    }
    EventBus.$on('workspace-change', this.redirectToIndex);
  }

  redirectToIndex() {
    this.$router.replace({
      name: 'presentation.index',
      params: getScopeFromRouter() as any,
      query: { tab: this.type }
    });
  }

  async updateName(name: string) {
    try {
      await updateStructure(this.type, this.id, { name });
    } catch (error) {}
  }

  openAssetLayer(id: string) {
    if (!id) return;
    changeQuery({ asset: id });
  }

  async pdf() {
    const { name }: { name: string } = this.detail;
    const fileName: string = `${moment().format('YYYYMMDD')}-${name.trim()}.pdf`;

    const link: HTMLAnchorElement = (await new ExportService().asPdf(
      this.id,
      this.type,
      fileName
    )) as HTMLAnchorElement;
    link && link.click();
  }

  async sitemap() {
    const { product, country }: ProductCountry = getScopeFromRouter() as ProductCountry;
    const productName: string = this.products.find((p: Product) => p._id === product)!.name;

    const token: string = localStorage.getItem('token') as string;
    const { name }: { name: string } = this.detail;
    const link: HTMLAnchorElement = (await new ExportService().sitemap(
      this.id,
      this.type,
      `${productName}-${name}-Sitemap.pdf`,
      token,
      { product, country }
    )) as HTMLAnchorElement;
    link && link.click();
  }

  async remove() {
    await confirm('Delete Presentation', 'Are you sure?', 'Yes', 'Cancel').then(async yes => {
      if (this.type === 'flow') {
        await this.deleteFlow(this.id);
        this.notifySuccess('Deleted Flow successfully');
      }

      if (this.type === 'chapter') {
        await this.deleteChapter(this.id);
      }

      this.redirectToIndex();
    });
  }

  deassign(slide: Slide, pos: number) {
    if (this.type === 'flow') {
      this.deassignSlideFromFlow({ entity: this.id, slide: slide._id, newPos: pos });
    }

    if (this.type === 'chapter') {
      this.deassignSlideFromChapter({ entity: this.id, slide: slide._id, newPos: pos });
    }
  }

  select(slide: Slide, pos: number) {
    const id = `${slide._id}-${pos}`;
    this.activeItem = this.activeItem === id ? null : id;
  }

  get presentUrl() {
    return new ExportService().presentation(
      this.id,
      this.type,
      <string>localStorage.getItem('token'),
      <ProductCountry>getScopeFromRouter()
    );
  }

  refreshIframe() {
    const _ref = this.$refs.preview as any;

    return _ref.contentWindow.location.reload(true);
  }

  onChange(event: DndEvent) {
    const { moved, added } = event;
    if (added) {
      const item = {
        entity: this.id,
        slide: added.element._id,
        pos: added.newIndex
      };

      if (this.type === 'flow') {
        this.assignSlideToFlow(item);
      } else if (this.type === 'chapter') {
        this.assignSlideToChapter(item);
      }
    }

    if (moved) {
      const item = {
        entity: this.id,
        slide: moved.element._id,
        oldPos: moved.oldIndex,
        newPos: moved.newIndex
      };

      if (this.type === 'flow') {
        this.sortFlow(item);
      } else if (this.type === 'chapter') {
        this.sortChapter(item);
      }
    }

    this.refreshIframe();
  }

  updateSlides(selection: { flow: string[]; chapter: string[]; wildcard: string }) {
    if (selection.flow) {
      this.setFilterItem({ key: 'flow', val: selection.flow });
    }
    if (selection.chapter) {
      this.setFilterItem({ key: 'chapter', val: selection.chapter });
    }
    if (selection.wildcard) {
      this.setFilterItem({ key: 'wildcard', val: selection.wildcard });
    }
  }
}
